import { Link } from 'react-router-dom';
import AnchorLink from '@/components/AnchorLink';
import { Container } from '@/components/Section';
import { NAV_LINKS } from '@/data/site';
import { SERVICES } from '@/data/services';

const LINK = 'text-sm text-white/75 hover:text-white transition-colors';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="on-dark bg-ink text-white border-t border-white/15" data-testid="site-footer">
      <Container className="py-12">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
          <img src="/garmond_logo.png" alt="Garmond Graphic" className="h-9 w-auto self-start" />
          <nav aria-label="Podnožje" className="flex flex-wrap gap-x-7 gap-y-3" data-testid="footer-nav">
            {NAV_LINKS.map((link) => (
              <AnchorLink
                key={link.href}
                href={link.href}
                data-testid={`footer-link-${link.href.slice(1)}`}
                className={LINK}
              >
                {link.label}
              </AnchorLink>
            ))}
            <Link to="/impresum" data-testid="footer-link-impresum" className={LINK}>
              Impresum
            </Link>
            <Link to="/politika-privatnosti" data-testid="footer-link-politika-privatnosti" className={LINK}>
              Politika privatnosti
            </Link>
          </nav>
        </div>
        <nav aria-label="Usluge" className="mt-8 flex flex-wrap gap-x-7 gap-y-3 border-t border-white/15 pt-6">
          {SERVICES.map((s) => (
            <Link key={s.id} to={s.path} className={LINK}>
              {s.title}
            </Link>
          ))}
        </nav>
        <div className="mt-10 flex flex-col gap-2 border-t border-white/15 pt-6 text-sm text-white/60 sm:flex-row sm:items-center sm:justify-between">
          <p>&copy; {year} Garmond Graphic Sarajevo. Sva prava zadržana.</p>
          <a
            href="https://konzul.art"
            rel="noopener"
            data-testid="footer-credit"
            className="hover:text-white transition-colors"
          >
            Dizajn: KONZULArt
          </a>
        </div>
      </Container>
    </footer>
  );
}
